import AggregateWidget from '../widgets/AggregateWidget';
//import AggregateWidget from '../widgets/AggregateWidget';
import { useReportData } from '../../hooks/data/useReportData';
import DynamicTable from '../tables/dynamicTable';
import { CircularProgress } from '@mui/material';

function WidgetType({ widgetInfo }) {
  const { data } = useReportData(widgetInfo.name, 1000, widgetInfo.params);
  if (!data) return <div><CircularProgress /></div>;

  switch (widgetInfo.type) {
    case 'Simple':
      return (
        <AggregateWidget
          key={widgetInfo.name}
          name={widgetInfo.name}
          data={data}
          agg={widgetInfo.agg}
          field={widgetInfo.field}
        />
      );
    case 'Table':
      return (
        <DynamicTable dataObject={data} defaultSize="small" minWidth='50' />
      );
    default:
      return <div>Widget not found: {widgetInfo.name}</div>;
  }
}

export default WidgetType;
